import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { messageIcon, MessageType } from '../message-type';

@Component({selector:'app-message-dialog', standalone:true, imports:[CommonModule], templateUrl:'./message-dialog.component.html'})
export class MessageDialogComponent {
  title = '';
  message = '';
  detail = '';
  confirmLabel = 'Confirm';
  cancelLabel = 'Cancel';
  severity: MessageType = 'confirmation';
  destructive = false;
  busy = false;
  isRTL = false;
  constructor(public activeModal: NgbActiveModal) {}
  get icon() { return messageIcon(this.severity); }
}
